/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetProductName {
    GoHotelkonzept = 'GoHotelkonzept',
    GoBauHaftpflicht = 'GoBauHaftpflicht',
    GoBauHaftpflichtExcedent = 'GoBauHaftpflichtExcedent',
    GewerblicheSachversicherung = 'GewerblicheSachversicherung',
    GewerblicheHaftpflichtversicherung = 'GewerblicheHaftpflichtversicherung',
    CallidusBvsHaftpflicht = 'CallidusBvsHaftpflicht',
    CallidusBvsHaftpflichtUndKasko = 'CallidusBvsHaftpflichtUndKasko',
    CallidusSkipperHaftpflicht = 'CallidusSkipperHaftpflicht',
    CallidusSkipperRechtsschutz = 'CallidusSkipperRechtsschutz',
    CallidusCharterKaution = 'CallidusCharterKaution',
    ServoKaufpreisKasko = 'ServoKaufpreisKasko',
    ServoBikeEBike = 'ServoBikeEBike',
    ServoElektronik = 'ServoElektronik',
    ServoGarantieverlaengerung = 'ServoGarantieverlaengerung',
    Vera = 'Vera'
  }

    export const BrokernetProductNameTranslocoMap: Record<BrokernetProductName, string> = {
    [BrokernetProductName.GoHotelkonzept]: 'brokernetProductName.goHotelkonzept',
    [BrokernetProductName.GoBauHaftpflicht]: 'brokernetProductName.goBauHaftpflicht',
    [BrokernetProductName.GoBauHaftpflichtExcedent]: 'brokernetProductName.goBauHaftpflichtExcedent',
    [BrokernetProductName.GewerblicheSachversicherung]: 'brokernetProductName.gewerblicheSachversicherung',
    [BrokernetProductName.GewerblicheHaftpflichtversicherung]: 'brokernetProductName.gewerblicheHaftpflichtversicherung',
    [BrokernetProductName.CallidusBvsHaftpflicht]: 'brokernetProductName.callidusBvsHaftpflicht',
    [BrokernetProductName.CallidusBvsHaftpflichtUndKasko]: 'brokernetProductName.callidusBvsHaftpflichtUndKasko',
    [BrokernetProductName.CallidusSkipperHaftpflicht]: 'brokernetProductName.callidusSkipperHaftpflicht',
    [BrokernetProductName.CallidusSkipperRechtsschutz]: 'brokernetProductName.callidusSkipperRechtsschutz',
    [BrokernetProductName.CallidusCharterKaution]: 'brokernetProductName.callidusCharterKaution',
    [BrokernetProductName.ServoKaufpreisKasko]: 'brokernetProductName.servoKaufpreisKasko',
    [BrokernetProductName.ServoBikeEBike]: 'brokernetProductName.servoBikeEBike',
    [BrokernetProductName.ServoElektronik]: 'brokernetProductName.servoElektronik',
    [BrokernetProductName.ServoGarantieverlaengerung]: 'brokernetProductName.servoGarantieverlaengerung',
    [BrokernetProductName.Vera]: 'brokernetProductName.vera',
    };

    export const BrokernetProductNameOptions = [
  { value: BrokernetProductName.GoHotelkonzept, labelKey: 'brokernetProductName.goHotelkonzept' },
  { value: BrokernetProductName.GoBauHaftpflicht, labelKey: 'brokernetProductName.goBauHaftpflicht' },
  { value: BrokernetProductName.GoBauHaftpflichtExcedent, labelKey: 'brokernetProductName.goBauHaftpflichtExcedent' },
  { value: BrokernetProductName.GewerblicheSachversicherung, labelKey: 'brokernetProductName.gewerblicheSachversicherung' },
  { value: BrokernetProductName.GewerblicheHaftpflichtversicherung, labelKey: 'brokernetProductName.gewerblicheHaftpflichtversicherung' },
  { value: BrokernetProductName.CallidusBvsHaftpflicht, labelKey: 'brokernetProductName.callidusBvsHaftpflicht' },
  { value: BrokernetProductName.CallidusBvsHaftpflichtUndKasko, labelKey: 'brokernetProductName.callidusBvsHaftpflichtUndKasko' },
  { value: BrokernetProductName.CallidusSkipperHaftpflicht, labelKey: 'brokernetProductName.callidusSkipperHaftpflicht' },
  { value: BrokernetProductName.CallidusSkipperRechtsschutz, labelKey: 'brokernetProductName.callidusSkipperRechtsschutz' },
  { value: BrokernetProductName.CallidusCharterKaution, labelKey: 'brokernetProductName.callidusCharterKaution' },
  { value: BrokernetProductName.ServoKaufpreisKasko, labelKey: 'brokernetProductName.servoKaufpreisKasko' },
  { value: BrokernetProductName.ServoBikeEBike, labelKey: 'brokernetProductName.servoBikeEBike' },
  { value: BrokernetProductName.ServoElektronik, labelKey: 'brokernetProductName.servoElektronik' },
  { value: BrokernetProductName.ServoGarantieverlaengerung, labelKey: 'brokernetProductName.servoGarantieverlaengerung' },
  { value: BrokernetProductName.Vera, labelKey: 'brokernetProductName.vera' },
    ];

